import SkeletonTable from "@/components/SkeletonTable";
import { getListProgram } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

export default function MasterDaftarProgramPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listProgram"],
    queryFn: getListProgram,
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
